import { render } from "./ChartOfPopupDetails.vue?vue&type=template&id=748cd90a&scoped=true"
import script from "./ChartOfPopupDetails.vue?vue&type=script&lang=ts"
export * from "./ChartOfPopupDetails.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-748cd90a"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTable,QTr,QTh,QTd});
